import { colors, SectionHeader } from '@giphy/react-giphy-brand'
import styled from 'styled-components'

const FormHeader = styled(SectionHeader)`
    text-align: left;
    font-size: 13px;
    margin-bottom: 4px;
    color: ${colors.giphyLightGrey};
`

export default FormHeader
